/**
 * Mapping from oldId to claimTag used in user data structure
 */
const OLD_ID_TO_CLAIM_TAG = {
  'caap-101': '', // CAAP 101 has no claimTag, status is derived from other reviewers
  'caap': 'caap',
  'caap_plus': 'caap_plus',
  'mtp': 'mtp',
  'caap_lite': 'caap_lite',
};

/**
 * Mapping from claimTag to blocked status field in user data
 */
const CLAIM_TAG_TO_BLOCKED_FIELD = {
  'caap': 'isCaapBlocked',
  'caap_plus': 'isPlusBlocked',
  'mtp': 'isMtpBlocked',
};

export const REVIEWERS_DATA = [
  {
    oldId: 'caap-101',
    id: 'caap-101',
    claimTag: '', // Derived status from CAAP Knowledge/Practical
    name: 'CAAP 101',
    description: `Everything you need to know about the CAAP Licensure Exam. Learn about the exam requirements, how to apply for a permit, what to remember when entering the site, etc. Includes bonus tips and strategies for a smoother experience.`,
    path: '/caap-101',
  },
  {
    oldId: 'caap',
    id: 'caap-knowledge',
    claimTag: 'caap',
    name: 'CAAP Knowledge',
    description: `Review for your Civil Aviation Authority of the Philippines (CAAP) AMT or AVT licensure exam. Complete coverage for all Knowledge Test subjects in practice or mock exam modes.`,
    path: '/caap',
  },
  {
    oldId: 'caap_plus',
    id: 'caap-practical',
    claimTag: 'caap_plus',
    name: 'CAAP Practical',
    description: `Become more ready on your CAAP Skill Test by learning aircraft maintenance basic principles, terminologies, toolings, aircraft parts, and more by using this supplementary reviewer.`,
    path: '/plus',
  },
  {
    oldId: 'mtp',
    id: 'entrance-exam',
    claimTag: 'mtp',
    name: 'MTP Entrance',
    description: `Prepare for the latest topics used by aviation companies today for their Maintenance Training Program (MTP) entrance exams. Improve your exam skills and potentially get hired in this highly-rewarding industry!`,
    path: '/mtp-entrance',
  },
];


export const PRICING = {
  'caap-knowledge': {
    // Available durations: 3 months (default), or 1 month (alternate purchase)
    durations: [
      {
        duration: 90,
        durationInWords: '3 months',
        price: 3999,
      },
      {
        duration: 30,
        durationInWords: '1 month',
        price: 1999,
      },
    ],
  },
  'caap-practical': {
    durations: [
      {
        duration: 90,
        durationInWords: '3 months',
        price: 3999,
      },
    ],
  },
  'entrance-exam': {
    durations: [
      {
        duration: 90,
        durationInWords: '3 months',
        price: 3999,
      },
    ],
  },
  'full-airman-bundle': {
    durations: [
      {
        duration: 90,
        durationInWords: '3 months',
        price: 7999,
      },
    ],
  },
  'full-license-bundle': {
    durations: [
      {
        duration: 90,
        durationInWords: '3 months',
        price: 5999,
      },
    ],
  },
};

export { OLD_ID_TO_CLAIM_TAG, CLAIM_TAG_TO_BLOCKED_FIELD };